<template>
    <div class="alert-row">
        <div class="futeikan-icon" v-bind:class="{ is_futeikan: alert.individual_flag }"></div>
        <div class="alert-title"><span>{{alert.item_cd}}</span><br><span class="item_name">{{alert.item_name}}</span></div>
        <div class="message">
            <div class="nebiki_text_wrap" v-if="alert.nebiki_rate != 0">
                <span class="nebiki_parcentage_number">{{alert.nebiki_rate*100}}</span>
                <span class="nebiki_percentage_symbol">%</span>
            </div>
            <div v-else>
                <span>値引不要</span>                
            </div>
        </div>
        <div class="suryo_text_wrap">
            <span class="suryo">{{alert.zaiko_su}}</span>
            <span class="">個</span>
        </div>
    </div>
</template>

<style scoped>
.alert-row {
    height: 72px;
    margin: 15px 0;
    display: grid;
    grid-template-columns: 50px 1fr 85px 85px;
}

.alert-row > div {
    padding: 5px;
}

.ignore-button {
    margin-top: 12px;
}

.alert-title {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item_name {
    white-space: nowrap;
    word-break: keep-all;
    font-size: 20px;
}

.nebiki_text_wrap {
    margin-top: 16px;
}

.futeikan-icon.is_futeikan {
    background-image: url("/images/scale.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 40px;
    margin-top: 10px;
}

.suryo_text_wrap {
    margin-top: 16px;
}

.suryo_text_wrap .suryo {
    font-size: 22px;
}

.nebiki_parcentage_number {
    font-size: 22px;
}

.nebiki_percentage_symbol {
    font-size: 16px;
}

.publish-button {
    margin-top: 12px;
}
</style>

<script>
export default {
    name: 'TanpinNebiki',
    components: {
    },
    props: ['alert'],
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>

